// Check if mobile device
function isTouchDevice() {
	return 'ontouchstart' in document.documentElement;
}
  
(function($) {
	// Get Window Width and Height
	var windowWidth = $(window).outerWidth();
	var windowHeight = $(window).height();
	var documentHeight = $(document).height();

	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	if(isTouchDevice()){
		var navbarHeight = 0;
		var bookHeight = 0;
	} else {
		var navbarHeight = 640;
		var bookHeight = 67;
		var hidePhone = 100;
	}	

	$(window).scroll(function(event){
	    didScroll = true;
	});

	setInterval(function() {
	    if (didScroll) {
	        hasScrolled();
	        didScroll = false;
	    }
	}, 250);

	function hasScrolled() {
	    var st = $(this).scrollTop();
	    // Make sure they scroll more than delta
	    if(Math.abs(lastScrollTop - st) <= delta)
	        return;

	    // If they scrolled down and are past the navbar, add class .nav-up.
	    // This is necessary so you never see what is "behind" the navbar.
	    if (st > lastScrollTop && st > navbarHeight){
	        // Scroll Down
                $('body').addClass('submenu-active');
	    } else {
	        // Scroll Up
	        if(st < lastScrollTop) {
                $('body').addClass('submenu-active');
	        }
			if (st < navbarHeight) {
				$('body').removeClass('submenu-active');
			}
	    }
		lastScrollTop = st;
	}


	/* Document ready functions */
	$(document).ready(function (){
	});

	$(window).resize(function () {
    });

})(jQuery);